import typography from '../theme/typography';

const variants = [
  {
    props: { variant: 'pane-item' },
    style: {
      display: 'flex',
      justifyContent: 'space-between',
      paddingRight: '8px',
      flexWrap: 'wrap',
      '& > .MuiListItemText-primary': {
        fontSize: typography.htmlFontSize,
        fontWeight: typography.fontWeightMedium,
      },
    },
  },
];

export default variants;
